import adminAxiosInstance from "./api/adminAxiosInstance";

const createClient = async (clientData) => {
    const response = await adminAxiosInstance.post('client', clientData);
    return response.data;
};

const searchClients = async (limit, offset, searchTerm) => {
    const isNumeric = searchTerm && /^\d+$/.test(searchTerm);
    const params = new URLSearchParams({
        limit,
        offset,
        ...(searchTerm && { [isNumeric ? 'cpfCnpj' : 'name']: searchTerm }),
    });
    const response = await adminAxiosInstance.get(`client/search?${params.toString()}`);
    return response.data;
};

const updateVipStatus = async (clientId, isVip) => {
    const response = await adminAxiosInstance.patch(`client/${clientId}/vip-status`, isVip, {
        headers: { 'Content-Type': 'application/json' }
    });
    return response.data;
};

export const clientAdminService = {
    createClient,
    searchClients,
    updateVipStatus,
};